import { createContext, useContext } from 'react';

/**
 * A place in the app header, beside Feedback, where a page can put a control that must stay
 * in view while the page scrolls (Ask Buakei's chat history). Null outside the app shell.
 */
const HeaderSlotContext = createContext<HTMLElement | null>(null);

export const HeaderSlotProvider = HeaderSlotContext.Provider;

export function useHeaderSlot(): HTMLElement | null {
  return useContext(HeaderSlotContext);
}
